<template>
    <el-container :class="classObj">
        <!-- 头部 -->
        <div class="indeherader">
           <el-header class="flex nsherader">  
               <ns-header />
           </el-header>
        </div>
        <div class="sidebar">
             <ns-Sidebar />
        </div>
        <!-- <div class="navbar">
            <navbar />
        </div> -->
        <el-main class="indemain">
            <transition name="slide">
              <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view> 
          </keep-alive>
            </transition>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
            <!-- 右侧栏 -->
        </el-main>
        <!-- 底部 -->
        <div class="indefooter">
             <el-footer><ns-footer /></el-footer>
        </div>
    </el-container>
</template>
<script>
    import Navbar  from './components/Navbar'
    import NsFooter from "./components/NsFooter"
    import NsHeader from "./components/NsHeader"
    import NsSidebar from "./components/Sidebar"
    import { mapState } from 'vuex'
    export default {
        name: "",
        components: {
            NsFooter,
            NsHeader,
            NsSidebar,
            Navbar
        },
         computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device,
      needTagsView: state => state.settings.tagsView,
      fixedHeader: state => state.settings.fixedHeader
    }),
      classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
      }
    }
   },
        created() {
          console.log()
        },
        data: () => {
            return {
                is_show: true,
                scroolstyle:''
            }
        },
        mounted() {
             window.addEventListener('scroll',this.handleScroll,true)
        },
        watch: {},
        methods: {
                handleClickOutside() {
      this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
    },
            // 监听滚动条
             handleScroll(){
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            if(scrollTop > 800){
                this.scroolstyle = [{"background":'rgba(0,0,0,.8)'}]
            }else{
               this.scroolstyle = [{"background":'rgba(0,0,0,.2)'}] 
            }
    }
        },
        	destroyed() {
			// 离开该页面需要移除这个监听的事件，不然会报错
			window.removeEventListener("scroll", this.handleScroll)
		},

    }
</script>
<style lang="scss" scoped>
.el-left{
  display: flex;
}
.el-right{
  width: 100%;
  margin-left: 17%;;
}
.menu-left{
  background: #304156;
  position: fixed;
  left: 0;
  height: 100%;
}
.indeherader{
    height: 56px;
    position: fixed;
    top: 0;
    left: 240px;
    background-color: #fff;
    border-bottom: 1px solid rgb(235, 237, 240);
    width: calc(100% - 240px);
    .nsherader{
        width: 100%;
        margin: 0 auto;
        height: inherit !important;
    }
}
.navbar{
    width: calc(100% - 240px);
    height: 20px;
    position: fixed;
    left: 200px;
    top: 80px;
    padding: 20px;
}
.sidebar{
    width: 120px;
    background: #273543;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0px;
}

.hideSidebar{
   .sidebar{
    width: 54px;
   } 
   .indefooter,.indemain,.navbar{
     width: calc(100% - 54px);
     left: 54px;
   }
}
.indefooter{
    background: rgba(215, 215, 215, 1);
    height: 60px;
    position: fixed;
    left: 120px;
    bottom: 0px;
    width: calc(100% - 120px);
}
.indemain{
    width: calc(100% - 240px);
    height: calc(100vh - 120px);
    position: fixed;
    left: 240px;
    top: 57px;
    overflow: auto;
    background: #f7f8fa;
}
::v-deep{
    .sidebar{
        .el-menu{background: none !important;border: none !important;}
.el-submenu,.el-menu-item,.el-submenu__title,.el-menu-item [class^=el-icon-],.el-submenu [class^=el-icon-] {
  color: #fff;
}
.el-submenu__title i {
    color: #fff;
    padding-right: 20px;
}
.el-menu-item:hover,.el-submenu__title:hover{
    outline: 0;
    background-color: #263445 !important;

}
.el-menu-item:focus,.el-submenu__title:focus{
    outline: 0;
    background-color: #263445 !important;

}
    }
.hideSidebar .el-right{
  margin-left: 54px !important;
}
}
</style>
